<template>
  <div id="mapContainer">
    <!-- 지도 영역 -->
    <div id="mapWrapper">
      <div id="map"></div>
    </div>
    <!-- 로드뷰 영역 -->
    <div id="rvWrapper" :class="{'hide-rv': !overlayOn}">
      <div id="roadview" style="width:100%;height:100%;"></div>
    </div>
    <!-- 지도타입 컨트롤 -->
    <div class="map-control map-type-control">
      <span id="btnSkyview" class="map-control-btn map-type-btn selected-btn" @click="toggleMapType($event)">스카이뷰</span>
      <span id="btnDistrict" class="map-control-btn map-type-btn" @click="toggleDistrictView($event)">지적/경계</span>
      <span id="btnRoadView" class="map-control-btn map-type-btn hidden-xs-down" @click="toggleRoadView($event)">로드뷰</span>
      <span id="btnLandInfo" class="map-control-btn map-type-btn selected-btn" @click="toggleAreaInfo($event)">면적정보</span>
    </div>
    <!-- 지도 확대, 축소 컨트롤  -->
    <div v-if="!overlayOn" :class="['map-control', 'map-zoom-control', {'pull-bottom': !isOpen}]">
      <div class="map-control-btn map-zoom-btn" @click="setZoom('in')"
           data-toggle="tooltip" title="확대"><i class="glyphicon glyphicon-plus"></i></div>
      <div class="map-control-btn map-zoom-btn" @click="setZoom('out')"
           data-toggle="tooltip" title="축소"><i class="glyphicon glyphicon-minus"></i></div>
    </div>
    <!-- 지도 기능 컨트롤  -->
    <div v-if="!overlayOn" class="map-control map-tool-control hidden-xs-down">
      <div data-toggle="tooltip"
           title="거리"
           :class="['map-control-btn', 'map-tool-btn', { 'selected-btn': selectTool === 'distance' }]"
           @click="drawDistance()"
      >
        거리
      </div>
      <div data-toggle="tooltip"
           title="면적"
           :class="['map-control-btn', 'map-tool-btn', { 'selected-btn': selectTool === 'area' }]"
           @click="drawPolygon()"
      >
        면적
      </div>
      <div data-toggle="tooltip"
           title="반경"
           :class="['map-control-btn', 'map-tool-btn', { 'selected-btn': selectTool === 'radius' }]"
           @click="drawRadius()"
      >
        반경
      </div>
      <div data-toggle="tooltip"
           title="초기화"
           class="map-control-btn map-tool-btn"
           @click="removeOverlay()"
      >
        <i class="glyphicon glyphicon-refresh"></i>
      </div>
    </div>
    <!-- 다른창으로 열기 버튼 -->
    <div v-if="isOpen" class="map-control map-external-btn" @click="open" title="새창으로 열기">
      <span id="btnExternal"><i class="glyphicon glyphicon-new-window"></i></span>
    </div>
    <!-- FlashPlayer 다운로드 알림창 -->
    <div class="FlashPlayerDownload HIDDEN">
      <span class="close" @click="closeFlashPlayer()">닫기</span>
      <a class="download" href="http://get.adobe.com/flashplayer/" target="_blank">최신버전 다운로드</a>
      <a class="helplink" href="http://kakaomap.tistory.com/110" target="_blank">설치완료 후에도 계속 설치문구가 뜨는 경우</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'daum-map',
    props: {
      mapData: {
        type: Array,
        default () {
          return []
        }
      },
      loaderActive: {
        type: Boolean,
        default () {
          return false
        }
      },
      isOpen: {
        type: Boolean,
        default () {
          return false
        }
      },
      setArea: {
        type: Boolean,
        default () {
          return false
        }
      },
      setMarker: {
        type: Boolean,
        default () {
          return false
        }
      },
      setInfoWindow: {
        type: Boolean,
        default () {
          return false
        }
      }
    },
    data () {
      return {
        map: {},
        mapCenter: '',
        selectTool: '',
        drawingFlag: false,
        overlayOn: false,
        areaPolygonArr: [],
        infoWindowArr: [],
        markerArr: [],
        drawOverlayArr: [],
        reClient: null,
        rv: null,
        mapWalker: null,
        walker: null
      }
    },
    methods: {
      addArea () {
        if (this.setArea) {
          const map = this.map
          const mapData = this.mapData

          for (let i = 0; i < mapData.length; i++) {
            const ref = mapData[i].ref
            let path = []
            let markers = []

            // 면적 그리기 정보가 없을 경우 마커로 대체
            if (ref.length === 0) {
              markers.push(new daum.maps.Marker({
                position: new daum.maps.LatLng(mapData[i].lat, mapData[i].lng),
                map: this.map
              }))

              return
            }

            for (let j = 0; j < ref.length; j++) {
              path.push(new daum.maps.LatLng(ref[j][0], ref[j][1]))
            }

            const interRef = mapData[i].interRef
            let hole = []
            for (let k = 0; k < interRef.length; k++) {
              hole.push(new daum.maps.LatLng(interRef[k][0], interRef[k][1]))
            }

            this.areaPolygonArr.push(new daum.maps.Polygon({
              map: map,
              //path: path,
              // 구멍난 다각형 만들기 api sample. https://apis.map.kakao.com/web/sample/donut/
              path: [path, hole], // 좌표 배열의 배열로 하나의 다각형을 표시할 수 있습니다
              strokeWeight: 2,
              strokeColor: '#FF7133',
              strokeOpacity: 0.8,
              fillColor: '#FF7133',
              fillOpacity: 0.7
            }))

            this.areaPolygonArr[i].setMap(map)
          }
        }
      },
      removeArea () {
        for (let i = 0; i < this.areaPolygonArr.length; i++) {
          this.areaPolygonArr[i].setMap(null)
        }
      },
      addInfoWindow () {
        if (this.setInfoWindow) {
          const map = this.map
          const mapData = this.mapData

          for (let i = 0; i < mapData.length; i++) {
            this.infoWindowArr.push(new daum.maps.CustomOverlay({
              map: map,
              position : new daum.maps.LatLng(mapData[i].lat, mapData[i].lng),
              content : `<div class="info" style="opacity: 0.9;">${mapData[i].bunji}<br>면적 <span class="number">${this.setComma(mapData[i].area)}</span> m<sup>2</sup></div>`,
              yAnchor: 1.5
            }))

            this.infoWindowArr[i].setMap(map)
          }
        }
      },
      removeInfoWindow () {
        for (let i = 0; i < this.infoWindowArr.length; i++) {
          this.infoWindowArr[i].setMap(null)
        }
      },
      addMarker () {
        if (this.setMarker) {
          const map = this.map
          const mapData = this.mapData

          for (let i = 0; i < mapData.length; i++) {
            this.markerArr.push(new daum.maps.Marker({
              position: new daum.maps.LatLng(mapData[i].lat, mapData[i].lng),
              map: map
            }))

            this.markerArr[i].setMap(map)
          }
        }
      },
      removeMarker () {
        for (let i = 0; i < this.markerArr.length; i++) {
          this.markerArr[i].setMap(null)
        }
      },
      toggleAreaInfo (event) {
        // 지도에 기본으로 표시된 면적정보를 그리거나 지운다.
        const map = this.map
        const target = event.target
        const selected = target.classList.contains('selected-btn')

        if (selected) {
          this.removeArea()
          this.removeMarker()
          this.removeInfoWindow()
          target.classList.remove('selected-btn')
        } else {
          this.addArea()
          this.addMarker()
          this.addInfoWindow()
          target.classList.add('selected-btn')
        }
      },
      toggleMapType (event) {
        // 맵 유형 선택 (지도, 스카이뷰)
        const target = event.target
        const select = target.classList.contains('selected-btn')
        const map = this.map

        // selected-btn 클래스를 통해 선택 여부 판단
        if (!select) {
          map.setMapTypeId(daum.maps.MapTypeId.HYBRID)
          target.classList.add('selected-btn')
        } else {
          map.setMapTypeId(daum.maps.MapTypeId.ROADMAP)
          target.classList.remove('selected-btn')
        }
      },
      toggleDistrictView (event) {
        // 지적-경계도 활성화 여부를 선택한다.
        const target = event.target
        const select = target.classList.contains('selected-btn')
        const map = this.map

        // selected-btn 클래스를 통해 선택 여부 판단
        if (!select) {
          map.addOverlayMapTypeId(daum.maps.MapTypeId.USE_DISTRICT)
          target.classList.add('selected-btn')
        } else {
          map.removeOverlayMapTypeId(daum.maps.MapTypeId.USE_DISTRICT)
          target.classList.remove('selected-btn')
        }
      },
      toggleRoadView (event) {
        const vm = this
        const target = event.target
        const select = target.classList.contains('selected-btn')
        const map = this.map
        const container = document.getElementById('mapContainer')
        const rvContainer = document.getElementById('roadview')
        const btnRoadView = document.getElementById('btnRoadView')
        let startX
        let startY
        let startOverlayPoint

        // 로드뷰가 선택되어 있지 않을 경우,
        if (!select) {
          target.classList.add('selected-btn')
          // 오버레이 활성화 flag
          vm.overlayOn = true
          // 로드뷰 객체가 생성 안되어 있을 경우 생성
          if (!vm.rv) {
            try {
              vm.rv = new daum.maps.Roadview(rvContainer)
            } catch (e) {
              // 플래시 10 설치가 안되어 있을 경우, 다운로드 알림창 활성화
              // document.getElementsByClassName('FlashPlayerDownload').classList.add('Forefront')
              $('div.FlashPlayerDownload').attr('class', 'FlashPlayerDownload Forefront')
            }
            // 로드뷰를 조작할때 발생하는 값을 받아 map walker의 상태를 변경해 준다.
            daum.maps.event.addListener(vm.rv, 'viewpoint_changed', function () {
              // 이벤트가 발생할 때마다 로드뷰의 viewpoint값을 읽어, map walker에 반영
              const viewpoint = vm.rv.getViewpoint()
              vm.mapWalker.setAngle(viewpoint.pan)
            })
            // position값이 바뀔 때마다 map walker의 상태를 변경해 준다.
            daum.maps.event.addListener(vm.rv, 'position_changed', function () {
              // 이벤트가 발생할 때마다 로드뷰의 position값을 읽어, map walker에 반영
              const position = vm.rv.getPosition()
              vm.mapWalker.setPosition(position)
              map.setCenter(position)
            })
          }
          // 동동이가 생성 안되었을 경우 생성.
          if (!vm.mapWalker) {
            vm.mapWalker = new MapWalker(map.getCenter())
          }
          // 로드뷰 클라이언트가 생성안되었을 경우 생성.
          if (!vm.rvClient) {
            vm.rvClient = new daum.maps.RoadviewClient()
          }
          // 로드뷰 오버레이 활성화
          toggleOverlay(true)
        } else {
          closeRoadView()
        }

        /* 아래는 로드뷰와 관련된 함수들입니다 */
        // 지도 위의 로드뷰 도로 오버레이를 추가,제거하는 함수입니다
        function toggleOverlay (active) {
          if (active) {
            // 지도 위에 로드뷰 도로 오버레이를 추가합니다
            map.addOverlayMapTypeId(daum.maps.MapTypeId.ROADVIEW)
            // 지도 위에 마커를 표시합니다
            vm.mapWalker.setMap(map)
            // 마커의 위치를 지도 중심으로 설정합니다
            vm.mapWalker.setPosition(map.getCenter())

            // 커스텀 오버레이에 mousedown이벤트를 등록합니다
            vm.mapWalker.content.addEventListener('mousedown', onMouseDown, true)
            vm.mapWalker.content.addEventListener('mouseup', onMouseUp, true)

            // 로드뷰의 위치를 지도 중심으로 설정합니다
            toggleRoadview(map.getCenter())
          }
        }

        // 로드뷰를 설정하는 함수입니다
        function toggleRoadview (position) {
          vm.rvClient.getNearestPanoId(position, 50, function (panoId) {
            // 파노라마 ID가 null 이면 로드뷰를 숨깁니다
            if (panoId === null) {
              alert('로드뷰가 지원되지 않는 위치입니다.\n동동이를 드래그하여 지도에 표시된 파란색 선 위로 움직여주세요.')
              toggleMapWrapper(false, position)
            } else {
              toggleMapWrapper(true, position)
              // panoId로 로드뷰를 설정합니다
              vm.rv.setPanoId(panoId, position)
            }
          })
        }

        // 지도를 감싸고 있는 div의 크기를 조정하는 함수입니다
        function toggleMapWrapper (active, position) {
          if (active) {
            if (!container.classList.contains('view-roadview')) {
              container.classList.add('view-roadview')
              // 지도의 크기가 변경되었기 때문에 relayout 함수를 호출합니다
              map.relayout()
              // 지도의 너비가 변경될 때 지도중심을 입력받은 위치(position)로 설정합니다
              map.setCenter(position)
              vm.overlayOn = true
            }
          } else {
            // 지도를 감싸고 있는 div의 너비가 100%가 되도록 class를 변경합니다
            container.classList.remove('view-roadview')
            // 지도의 크기가 변경되었기 때문에 relayout 함수를 호출합니다
            map.relayout()
            // 지도의 너비가 변경될 때 지도중심을 입력받은 위치(position)로 설정합니다
            map.setCenter(position)
            // 오버레이 활성화 flag
            vm.overlayOn = false
          }
        }

        function closeRoadView () {
          btnRoadView.classList.remove('selected-btn')
          map.removeOverlayMapTypeId(daum.maps.MapTypeId.ROADVIEW)
          vm.mapWalker.setMap(null)
          vm.mapWalker = null
          vm.walker = null
          toggleMapWrapper(false, map.getCenter())
        }

        //  커스텀 오버레이에 사용할 map walker 엘리먼트
        function MapWalker (position) {
          let content = document.createElement('div')
          let figure = document.createElement('div')
          let angleBack = document.createElement('div')

          //  map walker를 구성하는 각 노드들의 class명을 지정 - style셋팅을 위해 필요
          content.className = 'MapWalker'
          figure.className = 'figure'
          angleBack.className = 'angleBack'
          content.appendChild(angleBack)
          content.appendChild(figure)

          //  커스텀 오버레이 객체를 사용하여, map walker 아이콘을 생성
          if (!vm.walker) {
            vm.walker = new daum.maps.CustomOverlay({
              position: position,
              content: content,
              yAnchor: 1
            })
          }

          /*  로드뷰의 pan(좌우 각도)값에 따라 map walker의 백그라운드 이미지를 변경 시키는 함수 */
          //  background로 사용할 sprite 이미지에 따라 계산 식은 달라 질 수 있음
          const setAngle = (angle) => {
            //  이미지가 변화되어야 되는(각도가 변해야되는) 임계 값
            const threshold = 22.5
            //  각도에 따라 변화되는 앵글 이미지의 수가 16개
            for (let i = 0; i < 16; i++) {
              if (angle > (threshold * i) && angle < (threshold * (i + 1))) {
                //  각도(pan)에 따라 아이콘의 class명을 변경
                let className = 'm' + i
                content.className = content.className.split(' ')[0]
                content.className += (' ' + className)
                break
              }
            }
          }
          //  map walker의 위치를 변경시키는 함수
          const setPosition = (position) => {
            vm.walker.setPosition(position)
          }
          //  map walker를 지도위에 올리는 함수
          const setMap = (marker) => {
            vm.walker.setMap(marker)
          }

          this.walker = vm.walker
          this.content = content
          this.setAngle = setAngle
          this.setPosition = setPosition
          this.setMap = setMap
        }

        // 커스텀 오버레이에 mousedown 했을 때 호출되는 핸들러 입니다
        function onMouseDown (e) {
          // 커스텀 오버레이를 드래그 할 때, 내부 텍스트가 영역 선택되는 현상을 막아줍니다.
          if (e.preventDefault) {
            e.preventDefault()
          } else {
            e.returnValue = false
          }
          let proj = map.getProjection() // 지도 객체로 부터 화면픽셀좌표, 지도좌표간 변환을 위한 MapProjection 객체를 얻어옵니다
          let overlayPos = vm.walker.getPosition() // 커스텀 오버레이의 현재 위치를 가져옵니다
          // 커스텀오버레이에서 마우스 관련 이벤트가 발생해도 지도가 움직이지 않도록 합니다
          daum.maps.event.preventMap()
          // mousedown된 좌표를 설정합니다
          startX = e.clientX
          startY = e.clientY
          // mousedown됐을 때의 커스텀 오버레이의 좌표를
          // 지도 컨테이너내 픽셀 좌표로 변환합니다
          startOverlayPoint = proj.containerPointFromCoords(overlayPos)
          // document에 mousemove 이벤트를 등록합니다
          document.addEventListener('mousemove', onMouseMove, true)
        }

        // 커스텀 오버레이에 mousedown 한 상태에서 mousemove 하면 호출되는 핸들러 입니다
        function onMouseMove (e) {
          // 커스텀 오버레이를 드래그 할 때, 내부 텍스트가 영역 선택되는 현상을 막아줍니다.
          if (e.preventDefault) {
            e.preventDefault()
          } else {
            e.returnValue = false
          }
          let proj = map.getProjection()// 지도 객체로 부터 화면픽셀좌표, 지도좌표간 변환을 위한 MapProjection 객체를 얻어옵니다
          let deltaX = startX - e.clientX // mousedown한 픽셀좌표에서 mousemove한 좌표를 빼서 실제로 마우스가 이동된 픽셀좌표를 구합니다
          let deltaY = startY - e.clientY
          // mousedown됐을 때의 커스텀 오버레이의 좌표에 실제로 마우스가 이동된 픽셀좌표를 반영합니다
          let newPoint = new daum.maps.Point(startOverlayPoint.x - deltaX, startOverlayPoint.y - deltaY)
          // 계산된 픽셀 좌표를 지도 컨테이너에 해당하는 지도 좌표로 변경합니다
          let newPos = proj.coordsFromContainerPoint(newPoint)
          // 커스텀 오버레이의 좌표를 설정합니다
          vm.walker.setPosition(newPos)
        }

        // mouseup 했을 때 호출되는 핸들러 입니다
        function onMouseUp (e) {
          // 등록된 mousemove 이벤트 핸들러를 제거합니다
          document.removeEventListener('mousemove', onMouseMove, true)
          let newPos = vm.walker.getPosition()
          vm.mapWalker.setPosition(newPos)
          // 클락한 위치를 기준으로 로드뷰를 설정합니다
          toggleRoadview(newPos)
        }
      },
      closeFlashPlayer () {
        $('div.FlashPlayerDownload').attr('class', 'FlashPlayerDownload HIDDEN')
      },
      drawDistance () {
        // 이미 선택 된 기능이 있을 경우 retrun
        if (this.selectTool) return

        const vm = this
        const map = this.map
        let moveLine // 선이 그려지고 있을때 마우스 움직임에 따라 그려질 선 객체 입니다
        let clickLine
        let distanceOverlay // 선의 거리정보를 표시할 커스텀오버레이 입니다
        vm.selectTool = 'distance'

        // 맵 마우스 클릭 이벤트
        const clickFunc = (event) => {
          let clickPosition = event.latLng
          // 지도 클릭이벤트가 발생했는데 선을 그리고있는 상태가 아니면
          if (!vm.drawingFlag) {
            // 상태를 true로, 선이 그리고있는 상태로 변경합니다
            vm.drawingFlag = true

            // 클릭한 위치를 기준으로 선을 생성하고 지도위에 표시합니다
            clickLine = new daum.maps.Polyline({
              map: map, // 선을 표시할 지도입니다
              path: [clickPosition], // 선을 구성하는 좌표 배열입니다 클릭한 위치를 넣어줍니다
              strokeWeight: 3, // 선의 두께입니다
              strokeColor: '#db4040', // 선의 색깔입니다
              strokeOpacity: 1, // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
              strokeStyle: 'solid' // 선의 스타일입니다
            })

            // 선이 그려지고 있을 때 마우스 움직임에 따라 선이 그려질 위치를 표시할 선을 생성합니다
            moveLine = new daum.maps.Polyline({
              strokeWeight: 3, // 선의 두께입니다
              strokeColor: '#db4040', // 선의 색깔입니다
              strokeOpacity: 0.5, // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
              strokeStyle: 'solid' // 선의 스타일입니다
            })

            //  커스텀 오버레이가 생성되지 않은 상태이면 커스텀 오버레이를 생성하고 지도에 표시합니다
            if (!distanceOverlay) {
              distanceOverlay = new daum.maps.CustomOverlay({
                xAnchor: 0,
                yAnchor: 0,
                zIndex: 3
              })
            }
          } else {
            // 그려지고 있는 선의 좌표 배열을 얻어옵니다
            let path = clickLine.getPath()
            // 좌표 배열에 클릭한 위치를 추가합니다
            path.push(clickPosition)
            // 다시 선에 좌표 배열을 설정하여 클릭 위치까지 선을 그리도록 설정합니다
            clickLine.setPath(path)
          }
        }

        // 맵 마우스 이동 이벤트
        const moveFunc = (event) => {
          if (vm.drawingFlag) {
            // 마우스 커서의 현재 위치를 얻어옵니다
            let mousePosition = event.latLng
            // 마우스 클릭으로 그려진 선의 좌표 배열을 얻어옵니다
            let path = clickLine.getPath()
            // 마우스 클릭으로 그려진 마지막 좌표와 마우스 커서 위치의 좌표로 선을 표시합니다
            let movepath = [path[path.length - 1], mousePosition]
            moveLine.setPath(movepath)
            moveLine.setMap(map)

            let distance = Math.round(clickLine.getLength() + moveLine.getLength()) // 선의 총 거리를 계산합니다
            // 거리와 도보 시간, 자전거 시간을 가지고 HTML Content를 만들어 리턴합니다
            let content = '<div class="info">'
            content += '총거리 <span class="number">' + vm.setComma(distance) + '</span>m'
            content += '<div class="info-explain">마우스 오른쪽 버튼을 클릭하면 그리기가 종료됩니다.</div>'
            content += '</div>'
            // 거리 정보를 표시할 커스텀 오버레이의 좌표를 마우스커서 위치로 설정합니다
            distanceOverlay.setPosition(mousePosition)
            // 거리 정보를 표시할 커스텀 오버레이의 표시할 내용을 설정합니다
            distanceOverlay.setContent(content)
            // 그려지고 있는 선의 거리정보 커스텀 오버레이를 지도에 표시합니다
            distanceOverlay.setMap(map)
          }
        }

        // 맵 오른쪽 마우스 클릭 이벤트
        const rightClickFunc = (event) => {
          if (vm.drawingFlag) {
            // 마우스무브로 그려진 선은 지도에서 제거합니다
            moveLine.setMap(null)
            moveLine = null
            // 마우스 클릭으로 그린 선의 좌표 배열을 얻어옵니다
            let path = clickLine.getPath()
            // 선을 구성하는 좌표의 개수가 2개 이상이면
            if (path.length > 1) {
              // 마지막 클릭 지점에 대한 거리 정보 커스텀 오버레이를 지웁니다
              let distance = Math.round(clickLine.getLength())
              let content = '<div class="info">총거리 <span class="number">' + vm.setComma(distance) + '</span>m</div>'

              // 거리정보를 나타낼 곳은 마지막 좌표로 합니다.
              distanceOverlay.setPosition(path[path.length - 1])
              // 거리 정보를 표시할 커스텀 오버레이의 표시할 내용을 설정합니다
              distanceOverlay.setContent(content)
              // 그려지고 있는 선의 거리정보 커스텀 오버레이를 지도에 표시합니다
              distanceOverlay.setMap(map)
              // 오버레이 객체 저장
              vm.drawOverlayArr.push([distanceOverlay, clickLine])
            } else {
              // 선을 구성하는 좌표의 개수가 1개 이하이면 표시되고 있는 선과 정보들을 지도에서 제거합니다.
              removeLine()
            }
          }
          // 그리기 상태변경, 맵 이벤트 초기화
          vm.drawingFlag = false
          removeMapEvent()
        }

        // 맵 이벤트 등록
        daum.maps.event.addListener(map, 'click', clickFunc)
        daum.maps.event.addListener(map, 'mousemove', moveFunc)
        daum.maps.event.addListener(map, 'rightclick', rightClickFunc)

        /*  아래는 거리재기 기능에 관련된 함수들입니다.  */
        // 클릭으로 그려진 선을 지도에서 제거하는 함수입니다
        const removeLine = () => {
          // 선 삭제
          if (clickLine) {
            clickLine.setMap(null)
            clickLine = null
          }
          // 거리정보 삭제
          if (distanceOverlay) {
            distanceOverlay.setMap(null)
            distanceOverlay = null
          }
        }

        // 선택된 기능 버튼 및 맵 이벤트 초기화
        const removeMapEvent = () => {
          vm.selectTool = ''
          daum.maps.event.removeListener(map, 'click', clickFunc)
          daum.maps.event.removeListener(map, 'mousemove', moveFunc)
          daum.maps.event.removeListener(map, 'rightclick', rightClickFunc)
        }
      },
      drawPolygon () {
        // 이미 선택 된 기능이 있을 경우 retrun
        if (this.selectTool) return

        const vm = this
        const map = this.map
        let drawingPolygon
        let polygon
        let areaOverlay
        vm.selectTool = 'area'

        // 맵 마우스 클릭 이벤트
        const clickFunc = (event) => {
          let clickPosition = event.latLng
          // 지도 클릭이벤트가 발생했는데 선을 그리고있는 상태가 아니면
          if (!vm.drawingFlag) {
            // 상태를 true로, 선이 그리고있는 상태로 변경합니다
            vm.drawingFlag = true
            // 그려지고 있는 다각형을 표시할 다각형을 생성하고 지도에 표시합니다
            drawingPolygon = new daum.maps.Polygon({
              map: map, // 다각형을 표시할 지도입니다
              path: [clickPosition], // 다각형을 구성하는 좌표 배열입니다 클릭한 위치를 넣어줍니다
              removable: true, // 그린 후 삭제 할 수 있도록 x 버튼이 표시됩니다
              strokeWeight: 3, // 선의 두께입니다
              strokeColor: '#00a0e9', // 선의 색깔입니다
              strokeOpacity: 1, // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
              strokeStyle: 'solid', // 선의 스타일입니다
              fillColor: '#00a0e9', // 채우기 색깔입니다
              fillOpacity: 0.4 // 채우기 불투명도입니다
            })

            // 그리기가 종료됐을때 지도에 표시할 다각형을 생성합니다
            polygon = new daum.maps.Polygon({
              path: [clickPosition], // 다각형을 구성하는 좌표 배열입니다 클릭한 위치를 넣어줍니다
              strokeWeight: 3, // 선의 두께입니다
              strokeColor: '#00a0e9', // 선의 색깔입니다
              strokeOpacity: 1, // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
              strokeStyle: 'solid', // 선의 스타일입니다
              fillColor: '#00a0e9', // 채우기 색깔입니다
              fillOpacity: 0.4 // 채우기 불투명도입니다
            })

            // 면적정보가 표시될 영역 생성
            if (!areaOverlay) {
              areaOverlay = new daum.maps.CustomOverlay({
                xAnchor: 0,
                yAnchor: 0,
                zIndex: 1
              })
            }
          } else {
            const drawingPath = drawingPolygon.getPath()
            drawingPath.push(clickPosition)
            drawingPolygon.setPath(drawingPath)

            let path = polygon.getPath()
            path.push(clickPosition)
            polygon.setPath(path)
          }
        }

        // 맵 마우스 이동 이벤트
        const moveFunc = (event) => {
          if (vm.drawingFlag) {
            let mousePosition = event.latLng
            // 그려지고있는 다각형의 좌표배열을 얻어옵니다
            let path = drawingPolygon.getPath()
            // 반경 정보를 표시할 커스텀오버레이의 내용입니다
            let area = Math.round(drawingPolygon.getArea()) // 다각형의 총면적을 계산합니다
            let content = '<div class="info">'
            content += '총면적 <span class="number">' + vm.setComma(area) + '</span>m<sup>2</sup>'
            content += '<div class="info-explain">마우스 오른쪽 버튼을 클릭하면 그리기가 종료됩니다.</div>'
            content += '</div>'
            // 반경 정보를 표시할 커스텀 오버레이의 좌표를 마우스커서 위치로 설정합니다
            areaOverlay.setPosition(mousePosition)
            // 반경 정보를 표시할 커스텀 오버레이의 표시할 내용을 설정합니다
            areaOverlay.setContent(content)
            // 그려지고 있는 원의 반경정보 커스텀 오버레이를 지도에 표시합니다
            areaOverlay.setMap(map)
            // 마우스무브로 추가된 마지막 좌표를 제거합니다
            if (path.length > 1) {
              path.pop()
            }
            // 마우스의 커서 위치를 좌표 배열에 추가합니다
            path.push(mousePosition)
            // 그려지고 있는 다각형의 좌표를 다시 설정합니다
            drawingPolygon.setPath(path)
          }
        }

        // 맵 오른쪽 마우스 클릭 이벤트
        const rightClickFunc = (event) => {
          if (vm.drawingFlag) {
            // 그려지고있는 다각형을  지도에서 제거합니다
            drawingPolygon.setMap(null)
            drawingPolygon = null
            // 클릭된 죄표로 그릴 다각형의 좌표배열을 얻어옵니다
            let path = polygon.getPath()
            if (path.length > 2) {
              // 지도에 다각형을 표시합니다
              polygon.setMap(map)
              let area = Math.round(polygon.getArea()) // 다각형의 총면적을 계산합니다
              let content = '<div class="info">총면적 <span class="number"> ' + vm.setComma(area) + '</span> m<sup>2</sup></div>'

              // 면적정보를 나타낼 곳은 마지막 좌표로 합니다.
              areaOverlay.setPosition(path[path.length - 1])
              // 반경 정보를 표시할 커스텀 오버레이의 표시할 내용을 설정합니다
              areaOverlay.setContent(content)
              // 그려지고 있는 원의 반경정보 커스텀 오버레이를 지도에 표시합니다
              areaOverlay.setMap(map)
              // 오버레이 객체 저장
              vm.drawOverlayArr.push([polygon, areaOverlay])
            } else {
              // 다각형을 구성하는 좌표가 2개 이하이면 다각형을 지도에 표시하지 않습니다
              polygon = null
              areaOverlay.setMap(null)
            }
          }
          // 그리기 상태변경, 맵 이벤트 초기화
          vm.drawingFlag = false
          removeMapEvent()
        }

        // 맵 이벤트 등록
        daum.maps.event.addListener(map, 'click', clickFunc)
        daum.maps.event.addListener(map, 'mousemove', moveFunc)
        daum.maps.event.addListener(map, 'rightclick', rightClickFunc)

        // 선택된 기능 버튼 및 맵 이벤트 초기화
        const removeMapEvent = () => {
          vm.selectTool = ''
          daum.maps.event.removeListener(map, 'click', clickFunc)
          daum.maps.event.removeListener(map, 'mousemove', moveFunc)
          daum.maps.event.removeListener(map, 'rightclick', rightClickFunc)
        }
      },
      drawRadius () {
        // 이미 선택 된 기능이 있을 경우 retrun
        if (this.selectTool) return

        const vm = this
        const map = this.map
        let centerPosition
        let drawingCircle
        let drawingLine
        let drawingOverlay
        vm.selectTool = 'radius'

        // 맵 마우스 클릭 이벤트
        const clickFunc = (event) => {
          if (!vm.drawingFlag) {
            vm.drawingFlag = true
            centerPosition = event.latLng
            // 그려지고 있는 원의 반경을 표시할 선 객체를 생성합니다
            if (!drawingLine) {
              drawingLine = new daum.maps.Polyline({
                strokeWeight: 3,
                strokeColor: '#00a0e9',
                strokeOpacity: 1,
                strokeStyle: 'solid'
              })
            }
            // 그려지고 있는 원을 표시할 원 객체를 생성합니다
            if (!drawingCircle) {
              drawingCircle = new daum.maps.Circle({
                strokeWeight: 1,
                strokeColor: '#00a0e9',
                strokeOpacity: 0.3,
                strokeStyle: 'solid',
                fillColor: '#00a0e9',
                fillOpacity: 0.4
              })
            }
            // 그려지고 있는 원의 반경 정보를 표시할 커스텀오버레이를 생성합니다
            if (!drawingOverlay) {
              drawingOverlay = new daum.maps.CustomOverlay({
                xAnchor: 0,
                yAnchor: 0,
                zIndex: 1
              })
            }
          }
        }
        // 마우스 이동 이벤트
        const moveFunc = (event) => {
          if (vm.drawingFlag) {
            let mousePosition = event.latLng
            // 그려지고 있는 선을 표시할 좌표 배열입니다. 클릭한 중심좌표와 마우스커서의 위치로 설정합니다
            let linePath = [centerPosition, mousePosition]
            // 그려지고 있는 선을 표시할 선 객체에 좌표 배열을 설정합니다
            drawingLine.setPath(linePath)
            // 원의 반지름을 선 객체를 이용해서 얻어옵니다
            let length = drawingLine.getLength()
            if (length > 0) {
              // 그려지고 있는 원의 중심좌표와 반지름입니다
              let circleOptions = {
                center: centerPosition,
                radius: length
              }
              // 그려지고 있는 원의 옵션을 설정합니다
              drawingCircle.setOptions(circleOptions)
              // 반경 정보를 표시할 커스텀오버레이의 내용입니다
              let radius = Math.round(drawingCircle.getRadius())
              let content = '<div class="info">'
              content += '반경 <span class="number">' + vm.setComma(radius) + '</span>m'
              content += '<div class="info-explain">마우스 오른쪽 버튼을 클릭하면 그리기가 종료됩니다.</div>'
              content += '</div>'
              // 반경 정보를 표시할 커스텀 오버레이의 좌표를 마우스커서 위치로 설정합니다
              drawingOverlay.setPosition(mousePosition)
              // 반경 정보를 표시할 커스텀 오버레이의 표시할 내용을 설정합니다
              drawingOverlay.setContent(content)
              // 그려지고 있는 원을 지도에 표시합니다
              drawingCircle.setMap(map)
              // 그려지고 있는 선을 지도에 표시합니다
              drawingLine.setMap(map)
              // 그려지고 있는 원의 반경정보 커스텀 오버레이를 지도에 표시합니다
              drawingOverlay.setMap(map)
            } else {
              drawingCircle.setMap(null)
              drawingLine.setMap(null)
              drawingOverlay.setMap(null)
            }
          }
        }

        // 마우스 우클릭 이벤트
        const rightClickFunc = (event) => {
          if (vm.drawingFlag) {
            // 마우스로 오른쪽 클릭한 위치입니다
            const rClickPosition = event.latLng
            // 원의 반경을 표시할 선 객체를 생성합니다
            const polyline = new daum.maps.Polyline({
              path: [centerPosition, rClickPosition], // 선을 구성하는 좌표 배열입니다. 원의 중심좌표와 클릭한 위치로 설정합니다
              strokeWeight: 3, // 선의 두께 입니다
              strokeColor: '#00a0e9', // 선의 색깔입니다
              strokeOpacity: 1, // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
              strokeStyle: 'solid' // 선의 스타일입니다
            })
            // 원 객체를 생성합니다
            const circle = new daum.maps.Circle({
              center: centerPosition, // 원의 중심좌표입니다
              radius: polyline.getLength(), // 원의 반지름입니다 m 단위 이며 선 객체를 이용해서 얻어옵니다
              strokeWeight: 1, // 선의 두께입니다
              strokeColor: '#00a0e9', // 선의 색깔입니다
              strokeOpacity: 0.4, // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
              strokeStyle: 'solid', // 선의 스타일입니다
              fillColor: '#00a0e9', // 채우기 색깔입니다
              fillOpacity: 0.5 // 채우기 불투명도입니다
            })
            let radius = Math.round(circle.getRadius()) // 원의 반경 정보를 얻어옵니다
            let content = '<div class="info">반경 <span class="number">' + vm.setComma(radius) + '</span>m</div>' // 커스텀 오버레이에 표시할 반경 정보입니다
            // 반경정보를 표시할 커스텀 오버레이를 생성합니다
            const radiusOverlay = new daum.maps.CustomOverlay({
              content: content, // 표시할 내용입니다
              position: rClickPosition, // 표시할 위치입니다. 클릭한 위치로 설정합니다
              xAnchor: 0,
              yAnchor: 0,
              zIndex: 1
            })
            // 원을 지도에 표시합니다
            circle.setMap(map)
            // 선을 지도에 표시합니다
            polyline.setMap(map)
            // 반경 정보 커스텀 오버레이를 지도에 표시합니다
            radiusOverlay.setMap(map)
            // 중심 좌표를 초기화 합니다
            centerPosition = null
            // 그려지고 있는 원, 선, 커스텀오버레이를 지도에서 제거합니다
            drawingCircle.setMap(null)
            drawingLine.setMap(null)
            drawingOverlay.setMap(null)
            // 오버레이 객체 저장
            vm.drawOverlayArr.push([polyline, circle, radiusOverlay])
          }
          // 그리기 상태 변경 맵 이벤트 초기화
          vm.drawingFlag = false
          removeMapEvent()
        }

        // 선택된 기능 버튼 및 맵 이벤트 초기화
        const removeMapEvent = () => {
          vm.selectTool = ''
          daum.maps.event.removeListener(map, 'click', clickFunc)
          daum.maps.event.removeListener(map, 'mousemove', moveFunc)
          daum.maps.event.removeListener(map, 'rightclick', rightClickFunc)
        }

        // 맵 이벤트 등록
        daum.maps.event.addListener(map, 'click', clickFunc)
        daum.maps.event.addListener(map, 'mousemove', moveFunc)
        daum.maps.event.addListener(map, 'rightclick', rightClickFunc)
      },
      setZoom (type) {
        // 줌 인, 줌 아웃에 따라 줌 Level 설정
        const map = this.map
        const addition = type === 'in' ? -1 : 1

        map.setLevel(map.getLevel() + addition)
      },
      setComma (data) {
        // 넘어온 데이터를 3자리마다 콤마처리
        let parseData = ''

        if (data || typeof data !== 'undefined') {
          const reg = /(^[+-]?\d+)(\d{3})/
          let n = (data + '')
          while (reg.test(n)) {
            n = n.replace(reg, '$1' + ',' + '$2')
          }

          parseData = n
        }

        return parseData
      },
      open () {
        this.$emit('open')
      },
      removeOverlay () {
        for (let i in this.drawOverlayArr) {
          for (let j in this.drawOverlayArr[i]) {
            this.drawOverlayArr[i][j].setMap(null)
          }
        }
      }
    },
    mounted () {
      const mapData = this.mapData
      if (mapData.length > 0) {
        this.mapCenter = new daum.maps.LatLng(mapData[0].lat, mapData[0].lng)
      } else {
        // 주소정보가 없을 경우 지도의 기본 위치를 법원로 128(해줌 주소)로 설정한다.
        this.mapCenter = new daum.maps.LatLng(37.4942165948, 127.0345032438)
      }

      const mapElement = document.getElementById('map')
      const mapOption = {
        center: this.mapCenter,
        mapTypeId: daum.maps.MapTypeId.HYBRID,
        level: 3
      }

      // 지도 생성
      this.map = new daum.maps.Map(mapElement, mapOption)

      // 생성된 지도에 정보를 표시한다.
      this.$nextTick(() => {
        this.addArea()
        this.addMarker()
        this.addInfoWindow()
      })
    }
  }
</script>

<style lang="scss">
  @import '../assets/css/map';
</style>

<style lang="scss" scoped>
  $map-primary-color: #39496b;

  #mapContainer {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
    #map {
      width: 100%;
      height: 100%;
    }
    .Forefront {
      display: block;
      z-index: 1000000;
    }

    /* 맵 컨트롤 관련 UI 공통 클래스 */
    .map-control {
      overflow: hidden;
      margin: 0;
      padding: 0;
      z-index: 1;

      .map-control-btn {
        display: block;
        text-align: center;
        line-height: 32px;
        color: #495057;
        background-color: #f8f8f8;
        font-size: 12px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: -0.8px;
        cursor: pointer;

        i {
          line-height: 32px;
          font-size: 9px;
          color: #212529;
        }

        &:hover {
          background-color: #e0e6ed;
          color: $map-primary-color;
          i { color: $map-primary-color; }
        }
      }
    }

    /* 맵 유형, 지적-경계 컨트롤 UI */
    .map-type-control {
      position: absolute;
      top: 24px;
      left: 24px;
      height: 32px;
      box-shadow: $z-depth-01;
      .map-type-btn {
        width: 108px;
        height: 32px;
        float: left;
      }
    }

    /* 맵 확대-축소 UI */
    .map-zoom-control {
      position: absolute;
      bottom: 76px;
      right: 24px;

      .map-zoom-btn {
        width: 32px;
        height: 32px;
        margin-bottom: 8px;
        box-shadow: $z-depth-01;
      }
    }

    /* 거리, 범위, 면적재기 UI */
    .map-tool-control {
      position: absolute;
      top: 24px;
      right: 24px;

      .map-tool-btn {
        width: 32px;
        height: 32px;
        /*margin-bottom: 8px;*/
        box-shadow: $z-depth-01;
        text-align: center;
        line-height: 34px;
        color: #495057;
        font-size: 9px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: -0.8px;
        cursor: pointer;
      }
    }

    /* 지도 새창으로 열기 버튼 */
    .map-external-btn {
      position: absolute;
      bottom: 24px;
      right: 24px;
      width: 48px;
      height: 48px;
      text-align: center;
      background-color: #f8f8f8;
      cursor: pointer;
      box-shadow: $z-depth-01;
      i {
        font-size: 18px;
        color: #212529;
        line-height: 48px;
      }
      &:hover {
        background-color: #e0e6ed;
        color: $map-primary-color;
        i { color: $map-primary-color; }
      }
    }
    .selected-btn {
      background-color: #e0e6ed !important;
      color: $map-primary-color !important;
      i {
        color: $map-primary-color !important;
      }
    }
    .pull-bottom { bottom: 24px; }
  }
</style>



// WEBPACK FOOTER //
// ../common/components/Map.vue